// extracted by mini-css-extract-plugin
export default {"split":"validateBankAc2_split__e10Qx"};